import React, { useReducer, useEffect, useState }  from 'react'
import './App.css';

import { useAuth } from "react-oidc-context"
import { ConfirmProvider } from 'material-ui-confirm';

import CabeceraPrincipal from './components/Cabecera/Header'
import CuerpoApp from './components/Cuerpo/CuerpoApp'
import PiePrincipal from './components/Pie/Footer'
//import RedirigirCtrl from './components/Ateka/RedirigirCtrl'

import getAviso from './services/getAviso'
//import Cookies from 'universal-cookie';


function getGuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
}


// PASO DE INFORMACIÓN ENTRE COMPONENTES
export const AppContext = React.createContext();

const idCorrelacionStart = getGuid();

const initialState = {
  idCorrelacion : idCorrelacionStart,
  arraySolicitudesRepresentacionPendientes : [],
  arraySolicitudesRepresentacionRespondidas : [],
  arraySolicitudesRepresentacionBajas : [],
  arraySolicitudesRepresentacionPendientesUI : [],
  arraySolicitudesRepresentacionRespondidasUI : [],  
  arraySolicitudesRepresentacionBajasUI : [],
  resetFiltrado : false,
  resetPagina0 : false,
  nifNombreUsuario : "",
  serviceHeaders : { 
    'HTTP_HEADER_IDCORRELACION': idCorrelacionStart,
    'HTTP_HEADER_NOMBREAPLICACION': 'HTN.SistemaRepresentaciones.Web',
    'Authorization': ''  
  }

};


function reducer(state, action) {
  switch (action.type) {
      case 'UPDATE_SOLICITUDES_PENDIENTES_STATUS':          
        return {
          ...state,              
          arraySolicitudesRepresentacionPendientes : action.data.sort(function(a,b){
            // Turn your strings into dates, and then subtract them to get a value that is either negative, positive, or zero.
            return new Date(b.fechaUltMod) - new Date(a.fechaUltMod);
          })
      }; 
      case 'UPDATE_SOLICITUDES_PENDIENTES_UI_STATUS':          
        return {
          ...state,              
          arraySolicitudesRepresentacionPendientesUI : action.data.sort(function(a,b){
            return new Date(b.fechaUltMod) - new Date(a.fechaUltMod);
          })
      }; 
      case 'UPDATE_SOLICITUDES_RESPONDIDAS_STATUS':          
        return {
          ...state,          
          arraySolicitudesRepresentacionRespondidas : action.data.sort(function(a,b){
            return new Date(b.fechaUltMod) - new Date(a.fechaUltMod);
          })
      };       
      case 'UPDATE_SOLICITUDES_RESPONDIDAS_UI_STATUS':          
        return {
          ...state,          
          arraySolicitudesRepresentacionRespondidasUI : action.data.sort(function(a,b){
            return new Date(b.fechaUltMod) - new Date(a.fechaUltMod);
          })
      };
      case 'UPDATE_SOLICITUDES_BAJAS_STATUS':          
        return {
          ...state,          
          arraySolicitudesRepresentacionBajas : action.data.sort(function(a,b){
            return new Date(b.fechaUltMod) - new Date(a.fechaUltMod);
          })
      };       
      case 'UPDATE_SOLICITUDES_BAJAS_UI_STATUS':          
        return {
          ...state,          
          arraySolicitudesRepresentacionBajasUI : action.data.sort(function(a,b){
            return new Date(b.fechaUltMod) - new Date(a.fechaUltMod);
          })
      };

      case 'UPDATE_RESET_FILTRADO':          
         return {
          ...state,            
          resetFiltrado : action.data
      }; 
      case 'UPDATE_RESET_PAGE':          
         return {
          ...state,            
          resetPagina0 : action.data
      }; 
      case 'UPDATE_HAY_USUARIO_AUTENTICADO':          
         return {
          ...state,            
          nifNombreUsuario : action.data
      }; 
      case 'UPDATE_HEADERS':          
         return {
          ...state,            
          serviceHeaders : action.data
      }; default:
          //TODO: LANZAR ERROR
          return initialState;
  }
}



function url_redirect(url){
  var X = setTimeout(function(){
      window.location.replace(url);
      return true;
  },300);

  if( window.location = url ){
      clearTimeout(X);
      return true;
  } else {
      if( window.location.href = url ){
          clearTimeout(X);
          return true;
      }else{
          clearTimeout(X);
          window.location.replace(url);
          return true;
      }
  }
  return false;
};


/////////////


function App() {
    
  const [state, dispatch] = useReducer(reducer, initialState);

  const [htmlAviso, setHtmlAviso] = useState("") 

  const auth = useAuth();

  useEffect(() => {
    if (!auth.isAuthenticated && !auth.isLoading){ //} && auth.activeNavigator != "signoutRedirect") {              
      auth.signinRedirect()        
    }
  });//, []); 

  
  if (auth.activeNavigator == "signoutRedirect") {    
  
    return (
    <>      
        <div className="col-sm-10 col-lg-offset-1 sin-float" id="bloque">            

            <div className="modal-header-img">
                <div style={{ display: 'flex', flexWrap: 'nowrap',}}>                
                    <h1 style={{ display: 'inline-block', textAlign : 'center', marginTop : '20px',}}>Censo de representación voluntaria de Hacienda Navarra y TEAFN</h1>     
                </div>  
            </div>


            <div className="modal-body">
                <div className="panel panel-default">
                    <div className="panel-body">
                        <p>
                            <strong>PARA TERMINAR DE CERRAR LA SESIÓN, CIERRE EL NAVEGADOR</strong>
                            <br/>
                        </p>
                    </div>                    
                </div>
            </div>
        </div>
        {//auth.activeNavigator: {auth.activeNavigator}
        }
    </>
    )      
  }

  if (!auth.isAuthenticated) {    
  
    return (
    <>      
        <div className="col-sm-10 col-lg-offset-1 sin-float" id="bloque">            

            <div className="modal-header-img">
                <div style={{ display: 'flex', flexWrap: 'nowrap',}}>                
                    <h1 style={{ display: 'inline-block', textAlign : 'center', marginTop : '20px',}}>Censo de representación voluntaria de Hacienda Navarra y TEAFN</h1>     
                </div>  
            </div>


            <div className="modal-body">
                <div className="panel panel-default">
                    <div className="panel-body">
                        <p>
                            <strong>REDIRIGIENDO A ATEKA</strong>
                            <br/>
                        </p>
                    </div>
                    <div className="con-margen-izq">
                        <br/>
                        Redirigiendo...<button onClick={auth.signinRedirect}>AUTENTICACIÓN - LOG IN</button>
                    </div>
                </div>
            </div>
        </div>
        {//auth.activeNavigator: {auth.activeNavigator}
        }
    </>
    )
  
  }

  if (auth.isLoading) {
    return (
    <>      
        <div className="col-sm-10 col-lg-offset-1 sin-float" id="bloque">            

            <div className="modal-header-img">
                <div style={{ display: 'flex', flexWrap: 'nowrap',}}>                
                    <h1 style={{ display: 'inline-block', textAlign : 'center', marginTop : '20px',}}>Censo de representación voluntaria de Hacienda Navarra y TEAFN</h1>     
                </div>  
            </div>


            <div className="modal-body">
                <div className="panel panel-default">
                    <div className="panel-body">
                        <p>
                            <strong>CARGANDO CREDENCIALES ATEKA</strong>
                            <br/>
                        </p>
                    </div>
                    <div className="con-margen-izq">
                        <br/>
                        Cargando...
                    </div>
                </div>
            </div>
        </div>
        {//auth.activeNavigator: {auth.activeNavigator}
        }
    </>
    )
    
  }

  if (auth.error) {
    return (
    <>      
        <div className="col-sm-10 col-lg-offset-1 sin-float" id="bloque">            

            <div className="modal-header-img">
                <div style={{ display: 'flex', flexWrap: 'nowrap',}}>                
                    <h1 style={{ display: 'inline-block', textAlign : 'center', marginTop : '20px',}}>Censo de representación voluntaria de Hacienda Navarra y TEAFN</h1>     
                </div>  
            </div>


            <div className="modal-body">
                <div className="panel panel-default">
                    <div className="panel-body">
                        <p>
                            <strong>ATEKA: ERROR O TOKEN CADUCADO</strong>
                            <br/>
                        </p>
                    </div>
                    <div className="con-margen-izq">
                        <br/>
                        Error o Token caducado: {auth.error.message} <br/> <button onClick={auth.signinRedirect}>AUTENTICACIÓN - LOG IN</button>
                    </div>
                </div>
            </div>
        </div>
        {//auth.activeNavigator: {auth.activeNavigator}
        }
    </>
    )
        
  }

  if (auth.isAuthenticated) {

    //eliminar del querystring el resto?
    //const originalUrl = encodeURIComponent(window.location.href);
    const updatedUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
    window.history.pushState({path:updatedUrl},'',updatedUrl);

    const urlEncoded = encodeURIComponent(updatedUrl);

    state.serviceHeaders.Authorization = auth.user?.access_token;    
    
    var avisadoKey = `${process.env.REACT_APP_AVISADO}`;
    var avisadoValue = sessionStorage.getItem(avisadoKey);

    if (avisadoValue == null || !avisadoValue){
      getAviso(auth.user?.access_token, urlEncoded).then(datos => {          
        sessionStorage.setItem(avisadoKey, true);
        if (datos.ok){                    
          if (datos.respuesta.contenido != null) {
            if (datos.respuesta.tipoAviso == 0){
              //aviso incrustrado
              setHtmlAviso(datos.respuesta.contenido);
            }
            else if (datos.respuesta.tipoAviso == 1){
              //aviso redirección
              url_redirect(datos.respuesta.contenido);
            }
          }
        }
        else{
            alert('Error al consultar avisos.');  
        }
      }).catch((error) => {
          alert("Ha ocurrido un error consultando el módulo de Avisos en SistemaRepresentaciones. Por favor póngase en contacto con soporte (soportec@navarra.es) facilitando el identificador de correlación.");        
      }) 
    }

    return ( 
      <>
        {htmlAviso!="" && 
          <div dangerouslySetInnerHTML={{ __html: htmlAviso }} />
        }

        {htmlAviso=="" &&            
          <AppContext.Provider value={{state, dispatch}}>
            
          
            <ConfirmProvider value={{state, dispatch}}>
              
              <CabeceraPrincipal></CabeceraPrincipal>      
              <CuerpoApp>
            
              </CuerpoApp>
              <PiePrincipal></PiePrincipal>

            </ConfirmProvider>
      
          </AppContext.Provider>                          
        }
      </>
    )
  }

}

export default App;
